import React from "react";
import { Col, Row, Input, DatePicker, Typography, Button, InputNumber } from "antd";
import * as Antd from "antd";
import { Title } from "@frontend/components/atoms/Title";
import { DATE_FORMAT } from "@frontend/constants/formats";
import { SelectionProcessesService } from "@frontend/src/core/services/selection_processes_service";
import moment from "moment";
const { Text } = Typography;
const { Form } = Antd;

const FormHiring = ({onSubmit, hiring, form, selection_process, readonly=false }) => {
  const { getFieldDecorator } = form
  const {
    hiring_type,
    charge_name,
    joining_date,
    direct_boss,
    work_area,
    cost_center,
    working_day,
    salary,
    functions,
    structural_salary,
    comments
  } = hiring

  const { TextArea } = Input

  const salaryHint = () => {
    const requisition_info = selection_process?.extra_attributes
    if (requisition_info?.position_min_salary && requisition_info?.position_max_salary) {
      return `Banda salarial establecida: $${requisition_info?.position_min_salary} - $${requisition_info?.position_max_salary}`
    }
  }

  return (
    <Form onSubmit={(e) => onSubmit(e, form)}>
      <Text>
        Desde aquí podrás establecer datos generales del proceso los que se visualizarán en el perfil de cada candidato. Desde cada perfil podrás editarlos para que se ajuste a la situación particular de cada uno.
      </Text>
      <Row style={{marginTop: 40}}>
        <Col sm={{ span: 11 }} xs={{ span: 24 }}>
          <Form.Item
            label="Tipo de contratación"
            name="hiring_type"
          >
            {getFieldDecorator("hiring_type", {
              initialValue: hiring_type,
            }
              )(
                <Input placeholder="Tipo de contratación" size="large" disabled={readonly == true} />
              )}
          </Form.Item>
        </Col>
        <Col sm={{ span: 11, offset: 2 }} xs={{ span: 24 }}>
          <Form.Item
            label="Nombre del cargo"
            name="charge_name"
          >
            {getFieldDecorator("charge_name", {
              initialValue: charge_name,
            })
              (
                <Input placeholder="Nombre del cargo" size="large" disabled={readonly == true} />
              )}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col sm={{ span: 11 }} xs={{ span: 24 }}>
          <Form.Item
            label="Jefe directo"
            name="direct_boss"
          >
            {getFieldDecorator("direct_boss", {
              initialValue: direct_boss,
            })
              (
                <Input placeholder="Jefe Directo" size="large" disabled={readonly == true} />
              )}
          </Form.Item>
        </Col>
        <Col sm={{ span: 11, offset: 2 }} xs={{ span: 24 }}>
          <Form.Item
            label="Área de trabajo"
            name="work_area"
          >
            {getFieldDecorator("work_area", {
              initialValue: work_area,
            })
              (
                <Input placeholder="Area de trabajo" size="large" disabled={readonly == true} />
              )}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col sm={{ span: 11 }} xs={{ span: 24 }}>
          <Form.Item
            label="Centro de costo"
            name="cost_center"
          >
            {getFieldDecorator("cost_center", {
              initialValue: cost_center,
            })
              (
                <Input placeholder="Centro de costos" size="large" disabled={readonly == true} />
              )}
          </Form.Item>
        </Col>
        <Col sm={{ span: 11, offset: 2 }} xs={{ span: 24 }}>
          <Form.Item label="Jornada" name="working_day">
            {getFieldDecorator("working_day", {
              initialValue: working_day,
            })
              (
                <Input placeholder="Jornada" size="large" disabled={readonly == true} />
              )}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col sm={{ span: 11 }} xs={{ span: 24 }}>
          <Form.Item
            label="Sueldo / Salario líquido acordado"
            name="salary"
            extra={salaryHint()}
          >
            {getFieldDecorator("salary", {
              initialValue: salary,
            })
              (
              <InputNumber
                min={0}
                name="salary"
                className="questions-form-currency-input"
                disabled={readonly == true}
              />
              )}
          </Form.Item>
        </Col>
        <Col sm={{ span: 11, offset: 2 }} xs={{ span: 24 }}>
          <Form.Item label="Fecha de ingreso" name="joining_date">
            {getFieldDecorator("joining_date", {
              initialValue: joining_date && moment(joining_date),
            })
              (
                <DatePicker placeholder="Seleccionar fecha" format={DATE_FORMAT} disabled={readonly == true} />
              )}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col sm={{ span: 24 }}>
          <Form.Item
            label="Funciones"
            name="functions"
          >
            {getFieldDecorator("functions", {
              initialValue: functions,
            })
              (
                <TextArea rows={4} placeholder="Funciones" disabled={readonly == true} />
              )}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col sm={{ span: 24 }}>
          <Form.Item
            label="Estructura salarial"
            name="structural_salary"
          >
            {getFieldDecorator("structural_salary", {
              initialValue: structural_salary,
            })
              (
                <TextArea rows={4} placeholder="Estructura salarial" disabled={readonly == true} />
              )}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col sm={{ span: 24 }}>
          <Form.Item
            label="Comentarios"
            name="comments"
          >
            {getFieldDecorator("comments",{
              initialValue: comments,
            })
              (
                <TextArea rows={4} placeholder="Comentarios" disabled={readonly == true} />
              )}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={23}>
          <Button type="primary" htmlType="submit" style={{ float: "right" }}>
            Guardar
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

const HiringForm = Form.create({name: "hiring_form"})(FormHiring)

export default HiringForm;
